import { useEffect, useRef, useState } from 'react'

import { useLocation } from 'react-router-dom'

import clsx from 'clsx'

import { AviaSuccess } from 'pages/payment-success/components/avia-success'

import { BuyTicketByPromoCodeResponse } from 'shared/api/BuyTicket'
import { CheckPayment, RESULT_PAYMENT } from 'shared/api/check-payment'

import s from './styles.module.scss'

const countRequestMax = 20

export const CertificateStatus = () => {
  const location = useLocation()

  const [status, setStatus] = useState<RESULT_PAYMENT>(RESULT_PAYMENT.LOADING)
  const countRequest = useRef<number>(0)

  const pagePromo: BuyTicketByPromoCodeResponse | null = location.state || null

  const getStatusCertificate = async (data: BuyTicketByPromoCodeResponse) => {
    try {
      const { data: requestData } =
        await CheckPayment.checkPaymentRequestByCertificate(data.payment_id)

      countRequest.current += 1

      if (requestData?.data?.status === 'SUCCESS') {
        return RESULT_PAYMENT.SUCCESS
      }

      if (requestData?.data?.status === 'CANCELLED') {
        return RESULT_PAYMENT.CANCELLED
      }

      return RESULT_PAYMENT.LOADING
    } catch (_) {
      return RESULT_PAYMENT.CANCELLED
    }
  }

  const getStatusRequest = (data: BuyTicketByPromoCodeResponse | null) => {
    if (!data?.payment_id) return

    const intervalId = setInterval(async () => {
      const status = await getStatusCertificate(data)

      if (status === 'SUCCESS' || status === 'CANCELLED') {
        clearInterval(intervalId)
        setStatus(status)
      }

      if (countRequest.current >= countRequestMax) {
        clearInterval(intervalId)
        setStatus(RESULT_PAYMENT.LOADING)
      }
    }, 1500)
  }

  useEffect(() => {
    if (pagePromo) getStatusRequest(pagePromo)
  }, [pagePromo])

  return (
    <div className={clsx({ [s.container]: status !== RESULT_PAYMENT.SUCCESS })}>
      <AviaSuccess status={status} />
    </div>
  )
}
